import React from 'react';
import { Row, Col, Tabs } from 'antd';
import '@ant-design/icons';

import { useAuth } from '../../../hooks/auth';
import UserForm from '../Cadastro/Usuario';
import UserGroupForm from '../Cadastro/GruposDeUsuario';
import ConsultForm from '../Cadastro/Consulta';
import { CustomerForm } from '../Cadastro/Cliente';
import { MatrizConsultaModule } from '../Cadastro/MatrizConsulta';
import * as S from '../Cadastro/styles.js';

export function ListagemCadastros() {
  const { temPermissao } = useAuth();

  return (
    <S.Wrapper>
      <Row gutter={[0, 0]} justify="space-between" align="middle">
        <Col
          justify="center"
          span={24}
          style={{
            padding: '0 26px 0 24px',
          }}
        >
          <Tabs defaultActiveKey="1" type="card" style={{ marginTop: '28px' }}>
            {temPermissao(['CadastroUsuario']) && (
              <S.StyledTabPane tab="Usuários" key="1" span={24}>
                <UserForm />
              </S.StyledTabPane>
            )}

            {temPermissao(['CadastroCliente']) && (
              <S.StyledTabPane tab="Clientes" key="2">
                <CustomerForm />
              </S.StyledTabPane>
            )}

            {temPermissao(['CadastroGrupoUsuario']) && (
              <S.StyledTabPane tab="Grupo de usuários" key="3">
                <UserGroupForm />
              </S.StyledTabPane>
            )}

            {temPermissao(['CadastroConsulta']) && (
              <S.StyledTabPane tab="Consultas" key="4">
                <ConsultForm />
              </S.StyledTabPane>
            )}

            {temPermissao(['CadastroMatriz']) && (
              <S.StyledTabPane tab="Matriz de consulta" key="5" mScroll>
                <MatrizConsultaModule />
              </S.StyledTabPane>
            )}
          </Tabs>
        </Col>
      </Row>
    </S.Wrapper>
  );
}
